module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h1 class="center">Import persons</h1>\r\n<div class="row top-margined">\r\n    <select id="import-type" data-placeholder="Select import type" class="col-md-3" style="margin: 20px 10px 10px 10px;">\r\n    </select>\r\n</div>\r\n\r\n<label class="control-label">Select File</label>\r\n<input id="file-input" name="file" type="file" class="file" multiple data-show-caption="true">\r\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/persons/import-persons-view.html
// module id = 475
// module chunks = 0